<template>
    <div class="download-panel">
        <div class="row row-cols-1 size-selector" v-if="content">
            <div role="radiogroup" v-if="content.attributes.content_type === 'image'">
                <div class="col" :class="{active: selectedSize === 'S'}"
                     v-if="content.relationships.size_info.s.size !== ''"
                     role="radio"
                     :aria-label="$t('accessibility.sSizeContent')"
                     :aria-checked="selectedSize === 'S' ? 'true' : 'false'"
                     @click="selectSize('S')"
                     @keyup.enter="selectSize('S')"
                     @keyup.space="selectSize('S')"
                     tabindex="0">
                    <div class="card">
                        <div class="card-body d-flex">
                            <div class="size-tip d-flex justify-content-center align-items-center" tabindex="0">
                                <h2>S</h2>
                                <p>{{ content.attributes.content_type === 'image' ? 'size' : 'HD' }}</p>
                            </div>
                            <div class="size-info" tabindex="0">
                                <div>
                                    <p>1280 × 720 pixel</p>
                                </div>
                                <p>{{ convertByteSize(parseInt(content.relationships.size_info.s.size)) }} / {{ content.attributes.codec }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col" :class="{active: selectedSize === 'M'}"
                     v-if="content.relationships.size_info.m.size !== ''"
                     role="radio"
                     :aria-label="$t('accessibility.mSizeContent')"
                     :aria-checked="selectedSize === 'M' ? 'true' : 'false'"
                     @click="selectSize('M')"
                     @keyup.enter="selectSize('M')"
                     @keyup.space="selectSize('M')"
                     tabindex="0">
                    <div class="card">
                        <div class="card-body d-flex">
                            <div class="size-tip d-flex justify-content-center align-items-center" tabindex="0">
                                <h2>M</h2>
                                <p>{{ content.attributes.content_type === 'image' ? 'size' : 'Full HD' }}</p>
                            </div>
                            <div class="size-info" tabindex="0">
                                <div>
                                    <p>1920 × 1080 pixel</p>
                                </div>
                                <p>{{ convertByteSize(parseInt(content.relationships.size_info.m.size)) }} / {{ content.attributes.codec }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col" :class="{active: selectedSize === 'L'}"
                     v-if="content.relationships.size_info.l.size !== ''"
                     role="radio"
                     :aria-label="$t('accessibility.lSizeContent')"
                     :aria-checked="selectedSize === 'L' ? 'true' : 'false'"
                     @click="selectSize('L')"
                     @keyup.enter="selectSize('L')"
                     @keyup.space="selectSize('L')"
                     tabindex="0">
                    <div class="card">
                        <div class="card-body d-flex">
                            <div class="size-tip d-flex justify-content-center align-items-center" tabindex="0">
                                <h2>L</h2>
                                <p>{{ content.attributes.content_type === 'image' ? 'size' : '4K' }}</p>
                            </div>
                            <div class="size-info" tabindex="0">
                                <p>{{ content.attributes.width }} × {{ content.attributes.height }} pixel</p>
                                <p>{{ convertByteSize(content.attributes.size) }} / {{ content.attributes.codec }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div role="radiogroup" v-else>
                <div class="col" :class="{active: selectedSize === 'S'}"
                     v-if="content.relationships.size_info.s.size !== ''"
                     role="radio"
                     :aria-label="$t('accessibility.sSizeContent')"
                     :aria-checked="selectedSize === 'S' ? 'true' : 'false'"
                     @click="selectSize('S')"
                     @keyup.enter="selectSize('S')"
                     @keyup.space="selectSize('S')"
                     tabindex="0">
                    <div class="card">
                        <div class="card-body d-flex">
                            <div class="size-tip d-flex justify-content-center align-items-center">
                                <div class="text-center" tabindex="0">
                                    <h2>S</h2>
                                    <p>HD</p>
                                </div>
                            </div>
                            <div class="size-info" tabindex="0">
                                <div>
                                    <p>1280 × 720 pixel</p>
                                </div>
                                <p>{{ convertByteSize(parseInt(content.relationships.size_info.s.size)) }} / {{ content.attributes.codec }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col" :class="{active: selectedSize === 'M'}"
                     v-if="content.relationships.size_info.m.size !== ''"
                     role="radio"
                     :aria-label="$t('accessibility.mSizeContent')"
                     :aria-checked="selectedSize === 'M' ? 'true' : 'false'"
                     @click="selectSize('M')"
                     @keyup.enter="selectSize('M')"
                     @keyup.space="selectSize('M')"
                     tabindex="0">
                    <div class="card">
                        <div class="card-body d-flex">
                            <div class="size-tip d-flex justify-content-center align-items-center">
                                <div class="text-center" tabindex="0">
                                    <h2>M</h2>
                                    <p>Full HD</p>
                                </div>
                            </div>
                            <div class="size-info" tabindex="0">
                                <div>
                                    <p>1920 × 1080 pixel</p>
                                </div>
                                <p>{{ convertByteSize(parseInt(content.relationships.size_info.m.size)) }} / {{ content.attributes.codec }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col" :class="{active: selectedSize === 'L'}"
                     v-if="content.relationships.size_info.l.size !== ''"
                     role="radio"
                     :aria-label="$t('accessibility.lSizeContent')"
                     :aria-checked="selectedSize === 'L' ? 'true' : 'false'"
                     @click="selectSize('L')"
                     @keyup.enter="selectSize('L')"
                     @keyup.space="selectSize('L')"
                     tabindex="0">
                    <div class="card">
                        <div class="card-body d-flex">
                            <div class="size-tip d-flex justify-content-center align-items-center">
                                <div class="text-center" tabindex="0">
                                    <h2>L</h2>
                                    <p>4K</p>
                                </div>
                            </div>
                            <div class="size-info" tabindex="0">
                                <p>3840 × 2160 pixel</p>
                                <p>{{ convertByteSize(parseInt(content.relationships.size_info.l.size)) }} / {{ content.attributes.codec }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col" :class="{active: selectedSize === 'XL'}"
                     v-if="content.relationships.size_info.xl.size !== ''"
                     role="radio"
                     :aria-label="$t('accessibility.xlSizeContent')"
                     :aria-checked="selectedSize === 'XL' ? 'true' : 'false'"
                     @click="selectSize('XL')"
                     @keyup.enter="selectSize('XL')"
                     @keyup.space="selectSize('XL')"
                     tabindex="0">
                    <div class="card">
                        <div class="card-body d-flex">
                            <div class="size-tip d-flex justify-content-center align-items-center">
                                <div class="text-center" tabindex="0">
                                    <h2>XL</h2>
                                    <p>8K</p>
                                </div>
                            </div>
                            <div class="size-info" tabindex="0">
                                <p>7680 × 4320 pixel</p>
                                <p>{{ convertByteSize(parseInt(content.relationships.size_info.xl.size)) }} / {{ content.attributes.codec }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col" :class="{active: selectedText}"
                 v-if="isPc()"
                 role="checkbox"
                 :aria-label="$t('accessibility.textContent')"
                 :aria-checked="selectedText ? 'true' : 'false'"
                 @click="selectText()"
                 @keyup.enter="selectText()"
                 @keyup.space="selectText()"
                 tabindex="0">
                <div class="card">
                    <div class="card-body d-flex">
                        <div class="size-tip d-flex">
                            <div class="text-center" tabindex="0">
                                <h2>T</h2>
                                <p>text</p>
                            </div>
                        </div>
                        <div class="size-info d-flex align-items-center" tabindex="0">
                            <svg class="ico_text-data" xmlns="http://www.w3.org/2000/svg" width="35" height="39" viewBox="0 0 35 39">
                                <g transform="translate(-886 -871)"><g transform="translate(886 871)" fill="#fff" stroke="#707070" stroke-width="1"><rect width="35" height="39" rx="2" stroke="none"/>
                                    <rect x="0.5" y="0.5" width="34" height="38" rx="1.5" fill="none"/></g><line x2="22" transform="translate(892.5 878.5)" fill="none" stroke="#707070" stroke-width="1"/>
                                    <line x2="22" transform="translate(892.5 884.5)" fill="none" stroke="#707070" stroke-width="1"/>
                                    <line x2="22" transform="translate(892.5 890.5)" fill="none" stroke="#707070" stroke-width="1"/>
                                    <line x2="22" transform="translate(892.5 896.5)" fill="none" stroke="#707070" stroke-width="1"/>
                                    <line x2="22" transform="translate(892.5 902.5)" fill="none" stroke="#707070" stroke-width="1"/>
                                </g>
                            </svg>
                            <div class="ml-3">
                                <p class="card-title">{{ $t('downloads.textData') }}</p>
                                <p class="card-text">{{ $t('downloads.format') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12">
                <ul role="list">
                    <li tabindex="0" role="listitem">
                        {{ $t('downloads.chooseSize') }}
                    </li>
                    <li tabindex="0" v-if="isPc()" role="listitem">
                        {{ $t('downloads.canDownloadTextData') }}
                    </li>
                    <li tabindex="0" v-if="content.attributes.image_type === 'searchConditions.imageTypes.vr'" role="listitem">
                        {{ $t('downloads.vrTextData') }}
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="isQuestionnaireVisible"
             class="questionnaire-modal-backdrop"
             @click.self="closeQuestionnaire">
            <div ref="questionnaire"
                 class="questionnaire-modal"
                 role="dialog"
                 aria-modal="true"
                 :aria-labelledby="questionnaireTitleId"
                 tabindex="-1"
                 @keydown.esc="closeQuestionnaire">
                <div class="questionnaire-modal-header">
                    <p :id="questionnaireTitleId" class="questionnaire-title">{{ $t('downloads.questionnaire.title') }}</p>
                    <button type="button"
                            class="questionnaire-close"
                            :aria-label="$t('accessibility.closeModal')"
                            @click="closeQuestionnaire">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="questionnaire-modal-content">
                <p class="questionnaire-guidance">{{ $t('downloads.questionnaire.guidance') }}</p>
                <div class="questionnaire-privacy-notice">
                    <p>{{ $t('downloads.questionnaire.privacyDescription') }}</p>
                    <ul>
                        <li>{{ $t('downloads.questionnaire.privacyNotes.usage') }}</li>
                        <li>{{ $t('downloads.questionnaire.privacyNotes.noPersonalInfo') }}</li>
                        <li>{{ $t('downloads.questionnaire.privacyNotes.statistics') }}</li>
                    </ul>
                </div>

            <fieldset>
                <legend>
                    {{ $t('downloads.questionnaire.purposes.label') }}
                    <span class="required">{{ $t('downloads.questionnaire.required') }}</span>
                    <span class="multiple-answers">{{ $t('downloads.questionnaire.multipleAnswers') }}</span>
                </legend>
                <label class="questionnaire-option" v-for="option in purposeOptions" :key="option">
                    <input type="checkbox" :value="option" v-model="questionnaire.purposes">
                    {{ $t('downloads.questionnaire.purposes.options.' + option) }}
                </label>
                <input v-if="questionnaire.purposes.includes('other')"
                       v-model.trim="questionnaire.purposeOther"
                       class="form-control questionnaire-other"
                       type="text"
                       maxlength="1000"
                       :aria-label="$t('downloads.questionnaire.otherInput')"
                       :placeholder="$t('downloads.questionnaire.otherInput')">
            </fieldset>

            <fieldset>
                <legend>
                    {{ $t('downloads.questionnaire.industries.label') }}
                    <span class="required">{{ $t('downloads.questionnaire.required') }}</span>
                    <span class="multiple-answers">{{ $t('downloads.questionnaire.multipleAnswers') }}</span>
                </legend>
                <label class="questionnaire-option" v-for="option in industryOptions" :key="option">
                    <input type="checkbox" :value="option" v-model="questionnaire.industries">
                    {{ $t('downloads.questionnaire.industries.options.' + option) }}
                </label>
                <input v-if="questionnaire.industries.includes('other')"
                       v-model.trim="questionnaire.industryOther"
                       class="form-control questionnaire-other"
                       type="text"
                       maxlength="1000"
                       :aria-label="$t('downloads.questionnaire.otherInput')"
                       :placeholder="$t('downloads.questionnaire.otherInput')">
            </fieldset>

            <fieldset>
                <legend>
                    {{ $t('downloads.questionnaire.media.label') }}
                    <span class="optional">{{ $t('downloads.questionnaire.optional') }}</span>
                    <span class="multiple-answers">{{ $t('downloads.questionnaire.multipleAnswers') }}</span>
                </legend>
                <label class="questionnaire-option" v-for="option in mediaOptions" :key="option">
                    <input type="checkbox" :value="option" v-model="questionnaire.media">
                    {{ $t('downloads.questionnaire.media.options.' + option) }}
                </label>
                <input v-if="questionnaire.media.includes('other')"
                       v-model.trim="questionnaire.mediaOther"
                       class="form-control questionnaire-other"
                       type="text"
                       maxlength="1000"
                       :aria-label="$t('downloads.questionnaire.otherInput')"
                       :placeholder="$t('downloads.questionnaire.otherInput')">
            </fieldset>

                <div class="publication-url" v-if="showsPublicationUrl">
                    <label>
                        {{ $t('downloads.questionnaire.publicationUrl') }}
                        <span class="optional">{{ $t('downloads.questionnaire.optional') }}</span>
                    </label>
                    <input v-model.trim="questionnaire.publicationUrl"
                           class="form-control"
                           type="url"
                           maxlength="2048"
                           placeholder="https://example.com/">
                </div>
                <div class="questionnaire-actions">
                    <button type="button"
                            class="btn btn-success"
                            :disabled="!canDownload || isDownloading"
                            @click="download">
                        {{ isDownloading ? $t('downloads.questionnaire.saving') : $t('downloads.download') }}
                    </button>
                </div>
                <p v-if="downloadError" class="download-error" role="alert">{{ downloadError }}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-center">
                <input type="checkbox"
                       tabindex="0"
                       class="checkbox"
                       role="checkbox"
                       :id="agreementId"
                       :aria-checked="isAgree ? 'true' : 'false'"
                       v-model="isAgree">
                <label :for="agreementId" v-html="$t('downloads.agree')"></label>
            </div>
        </div>
        <div class="row mt-3" v-if="isLicenseType">
            <div class="col-12 mb-3">
                <ul role="list">
                    <li role="listitem">{{ $t('downloads.additionalTerms') }}</li>
                </ul>
            </div>
            <div class="col-12 text-center">
                <span role="button"
                      @click="$refs.additionalTermsModal.open()"
                      @keyup.space="$refs.additionalTermsModal.open()"
                      tabindex="0">
                    {{ $t('downloads.readAdditionalTerms') }}
                </span>
            </div>
        </div>
        <div class="row">
            <div class="text-center btn-download">
                <button class="btn btn-success btn-block"
                        tabindex="0"
                        :disabled="!buttonIsEnabled || isDownloading"
                        :class="{disabled: !buttonIsEnabled || isDownloading}"
                        @click="handleDownloadClick">
                    <svg class="ico_download" xmlns="http://www.w3.org/2000/svg" width="20.631" height="16.631" viewBox="0 0 20.631 16.631">
                        <g transform="translate(0.116 0.016)"><g transform="translate(0.7 7.727)">
                            <path d="M19.7,10.3v7.608a.485.485,0,0,1-.435.466H1.135A.485.485,0,0,1,.7,17.908V10.3" transform="translate(-0.7 -10.3)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.631"/>
                        </g>
                            <g transform="translate(6.31 0.8)"><line y2="11.877" transform="translate(3.959)" stroke-width="1.631" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" fill="none"/><path d="M16.718,10.5l-3.959,4.347L8.8,10.5" transform="translate(-8.8 -2.97)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.631"/>
                            </g>
                        </g>
                    </svg>
                    {{ isDownloading ? $t('downloads.questionnaire.saving') : $t('downloads.download') }}
                </button>
                <p v-if="downloadError" class="download-error" role="alert">{{ downloadError }}</p>
            </div>
        </div>
        <additional-terms-modal ref="additionalTermsModal"
                                :content="content"
                                @additional-terms-modal-has-closed="$emit('additional-terms-modal-has-closed')">
        </additional-terms-modal>
    </div>
</template>

<script>
    import ApiRouter from "../Systems/ApiRouter";
    import Helper from "../Helper/Helper";
    import AdditionalTermsModal from "./AdditionalTermsModal";

    export default {
        name: "DownloadPanel",
        components: {AdditionalTermsModal},
        mixins: [ApiRouter, Helper],
        props: ['content'],
        data: function () {
            return {
                isAgree: false,
                agreementId: 'download-agree-' + Math.random().toString(36).slice(2),
                isAdditionalTermsAgree: false,
                selectedSize: '',
                selectedText: false,
                isDownloading: false,
                downloadError: '',
                isQuestionnaireVisible: false,
                questionnaireTrigger: null,
                bodyWasModalOpen: false,
                questionnaireTitleId: 'download-questionnaire-title-' + Math.random().toString(36).slice(2),
                questionnaire: {
                    purposes: [],
                    purposeOther: '',
                    industries: [],
                    industryOther: '',
                    media: [],
                    mediaOther: '',
                    publicationUrl: ''
                }
            }
        },
        beforeUnmount: function () {
            if (!this.bodyWasModalOpen) {
                document.body.classList.remove('modal-open');
            }
        },
        methods: {
            selectSize: function (size) {
                this.selectedSize = size;
            },
            selectText: function () {
                this.selectedText = ! this.selectedText;
            },
            handleDownloadClick: function () {
                if (!this.isQuestionnaireVisible) {
                    if (!this.canProceedToQuestionnaire) {
                        return;
                    }

                    this.openQuestionnaire();
                    return;
                }

                this.download();
            },
            openQuestionnaire: function () {
                this.questionnaireTrigger = document.activeElement;
                this.bodyWasModalOpen = document.body.classList.contains('modal-open');
                document.body.classList.add('modal-open');
                this.isQuestionnaireVisible = true;
                this.downloadError = '';
                this.$nextTick(() => this.$refs.questionnaire.focus());
            },
            closeQuestionnaire: function () {
                this.isQuestionnaireVisible = false;
                this.downloadError = '';
                this.resetQuestionnaire();
                if (!this.bodyWasModalOpen) {
                    document.body.classList.remove('modal-open');
                }
                this.$nextTick(() => {
                    if (this.questionnaireTrigger) {
                        this.questionnaireTrigger.focus();
                    }
                });
            },
            download: function () {
                if (!this.canDownload || this.isDownloading) {
                    return;
                }

                this.isDownloading = true;
                this.downloadError = '';

                window.axios.post(this.routes.downloadContents(this.$route.params.id), {
                    agree: this.isAgree,
                    size: this.selectedSize || 'T',
                    downloaded_text: this.selectedText,
                    purposes: this.questionnaire.purposes,
                    purpose_other: this.questionnaire.purposeOther,
                    industries: this.questionnaire.industries,
                    industry_other: this.questionnaire.industryOther,
                    media: this.questionnaire.media,
                    media_other: this.questionnaire.mediaOther,
                    publication_url: this.showsPublicationUrl ? this.questionnaire.publicationUrl : null
                })
                    .then((response) => {
                        if (this.selectedSize && response.data.download_url) {
                            this.sendDownloadResponse(response.data.download_url);
                        }

                        if (this.selectedText) {
                            this.downloadText();
                        }

                        this.closeQuestionnaire();
                        this.isAgree = false;
                        this.isAdditionalTermsAgree = false;
                    })
                    .catch(() => {
                        this.downloadError = this.$t('downloads.questionnaire.saveError');
                    })
                    .finally(() => {
                        this.isDownloading = false;
                    });
            },
            downloadText: function () {
                if (this.isPc() && this.selectedText) {
                    const blob = new Blob(
                        [this.content.relationships.details[this.$i18n.locale].content.replace(/(<br>|<br \/>)/gi, '')],
                        {"type":"text/plain"}
                        );
                    let link = document.createElement('a');
                    const objectUrl = window.URL.createObjectURL(blob);
                    link.href = objectUrl;
                    link.download = 'download.txt';
                    link.click();
                    window.URL.revokeObjectURL(objectUrl);
                }
            },
            sendDownloadResponse: function (url) {
                const link = document.createElement('a');
                link.href = url;
                link.click();
            },
            resetQuestionnaire: function () {
                this.questionnaire = {
                    purposes: [],
                    purposeOther: '',
                    industries: [],
                    industryOther: '',
                    media: [],
                    mediaOther: '',
                    publicationUrl: ''
                };
            }
        },
        computed: {
            buttonIsEnabled: function () {
                return this.canProceedToQuestionnaire;
            },
            canProceedToQuestionnaire: function () {
                if (this.isLicenseType) {
                    return this.selectedSize !== '' && this.isAgree && this.isAdditionalTermsAgree;
                }

                return (this.selectedSize !== '' || this.selectedText) && this.isAgree;
            },
            canDownload: function () {
                if (!this.questionnaireIsComplete) {
                    return false;
                }

                return this.canProceedToQuestionnaire;
            },
            purposeOptions: function () {
                return ['tourism_pr', 'education', 'research', 'exhibition', 'program_production',
                    'non_tourism_video_production', 'other'];
            },
            industryOptions: function () {
                return ['travel', 'broadcasting', 'local_government', 'educational_institution', 'individual', 'other'];
            },
            mediaOptions: function () {
                return ['corporate_website', 'personal_website', 'corporate_sns', 'personal_sns',
                    'newspaper_magazine', 'flyer_leaflet', 'other'];
            },
            showsPublicationUrl: function () {
                const targetMedia = ['corporate_website', 'corporate_sns', 'newspaper_magazine', 'flyer_leaflet'];
                return this.questionnaire.media.some((medium) => targetMedia.includes(medium));
            },
            questionnaireIsComplete: function () {
                return this.questionnaire.purposes.length > 0 &&
                    this.questionnaire.industries.length > 0 && this.publicationUrlIsValid;
            },
            publicationUrlIsValid: function () {
                if (!this.showsPublicationUrl || this.questionnaire.publicationUrl === '') {
                    return true;
                }

                try {
                    const url = new URL(this.questionnaire.publicationUrl);
                    return url.protocol === 'http:' || url.protocol === 'https:';
                } catch (error) {
                    return false;
                }
            },
            isLicenseType: function () {
                if (this.content) {
                    return this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.dazaifu' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.isejingu' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.kunozan' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.murakami' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.murakamiForChosenji' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.nachikumanotaisha' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.nageiredou' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.sazaedo' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.takeoonsen' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.yashimaji' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.about' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.ama' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.asukadera' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.futagoji' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.gyodaCityLocalMuseum' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.hakoneSekisho' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.jionji' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.kamakurabungakukan' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.kashiharajingu' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.kenchoji' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.kishutoshogu' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.oosakihachimangu' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.sendaitoshogu' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.shurijoato' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.konojinjya' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.wakayamajo' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.nihonkoku' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.wakanoura'||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.izakamakura' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.masamune' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.kongoji' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.muroji' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.nyonnkoya' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.tamahagane' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.itamiCityMuseum' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.kikumasamune' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.itami' ||
                        this.content.attributes.additional_restriction === 'searchConditions.additionalRestrictions.otaru'
                }
                return false;
            }
        },
        watch: {
            content: function () {
                this.isAgree = false;
                this.isAdditionalTermsAgree = false;
                this.selectedSize = '';
                this.selectedText = false;
                this.isDownloading = false;
                this.downloadError = '';
                this.isQuestionnaireVisible = false;
                this.questionnaireTrigger = null;
                this.bodyWasModalOpen = false;
                this.resetQuestionnaire();
            }
        }
    }
</script>

<style src="./DownloadPanel.scss" lang="scss" scoped />
